import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './components/App/App';
import { store } from './utils/redux/store/store';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material';
import { theme } from './theme/theme';
import { AuthProvider } from 'services/auth/AuthContext';
import { BrowserRouter } from 'react-router-dom';
import { ErrorProvider } from 'services/ErrorContext';

// dotenv.config();
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Provider store={store}>
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <React.StrictMode>
          <BrowserRouter>
            <ErrorProvider>
              <App />
            </ErrorProvider>
          </BrowserRouter>
        </React.StrictMode>
      </ThemeProvider>
    </AuthProvider>
  </Provider>
);
